export default {
      id: "location-usage",
      viewBox: "0 0 18 22",
      url: __webpack_public_path__ + "sprite.svg#location",
      toString: function () {
        return this.url;
      }
    }